module.exports = __webpack_public_path__ + "static/media/insta-icon.e5c81e9c.svg";